import { IconBase, IconComponent } from './BaseIcon';

export const MoreHorizontal: IconComponent = (props) => (
  <IconBase {...props}>
    <circle cx="3.7" cy="16" r="3.7" />
    <circle cx="16" cy="16" r="3.7" />
    <circle cx="28.3" cy="16" r="3.7" />
  </IconBase>
);
